import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getWorkOfficeList = (cityId) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.TABULAR_REPORT.GET_WORK_OFFICE_LIST(cityId)
  );
};

export default getWorkOfficeList;
